import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bedroomCanonical',
})
export class BedroomCanonicalPipe implements PipeTransform {
  transform(value: string | number, ...args: unknown[]): string {
    const numberValue = parseInt(value as string, 0);

    switch (numberValue) {
      case 0:
        return 'Studio';
      default:
        return `${numberValue} Bed`;
    }
  }
}
